<template>
  <div id="app">
    <Header></Header>
    <Cookies />
    <transition
      name="page"
      mode="out-in"
    >
      <router-view/>
    </transition>
  </div>
</template>

<script>

import Header from '@/components/Header.vue'
import Cookies from '@/components/Cookies.vue'
export default {
  components: {
    Header,
    Cookies
  }
}
</script>

<style lang="less">
 @import '~@/assets/css/global.css';
 .page-enter-active, .page-leave-active {
    transition: opacity 0.5s, transform 0.5s;
  }

  .page-enter, .page-leave-to {
    opacity: 0;
    transform: translateX(-30%);
  }

  form input[type="text"], form input[type="email"], form input[type="password"], form select, form textarea {
    border: none;
  }
</style>
